document.addEventListener('DOMContentLoaded', function () {
    // --- Shared helper: switch to a tab by index ---
    function switchToTab(index) {
        var tabLinks = document.querySelectorAll('.goal-tab-a');
        if (index < 0 || index >= tabLinks.length) return;

        var targetLink = tabLinks[index];
        var tabId = targetLink.getAttribute('data-id');
        var tabNumber = targetLink.getAttribute('data-tab');

        // Update content tabs
        document.querySelectorAll('.goal-tab').forEach(function (tab) {
            tab.classList.remove('goal-tab-active');
        });
        var selectedTab = document.querySelector(".goal-tab[data-id='" + tabId + "']");
        if (selectedTab) {
            selectedTab.classList.add('goal-tab-active');
        }

        // Update tab pills
        tabLinks.forEach(function (link) {
            link.classList.remove('active-a');
        });
        targetLink.classList.add('active-a');

        // Update tab menu ul classes
        document.querySelectorAll('.goal-tab-menu ul').forEach(function (ul) {
            ul.className = '';
            ul.classList.add('goal-tab' + tabNumber);
        });

        // Switch images
        document.querySelectorAll('.goal-image-tabs').forEach(function (imgTab) {
            imgTab.classList.remove('goal-image-tabs-active');
        });
        var selectedImageTab = document.querySelector(".goal-image-tabs[data-id='goal-image-tab-" + tabId + "']");
        if (selectedImageTab) {
            selectedImageTab.classList.add('goal-image-tabs-active');
        }

        // Update section background gradient
        var sectionEl = document.querySelector('.goal-selector-section');
        if (sectionEl) {
            var sectionWrapper = document.querySelector('#shopify-section-' + sectionEl.getAttribute('data-section-id'));
            if (sectionWrapper && selectedTab) {
                var gradient = selectedTab.getAttribute('data-gradient');
                if (gradient) {
                    sectionWrapper.style.background = gradient;
                }
            }
        }

        // Scroll tab pill into view
        goalScroll(targetLink);
    }

    // --- Get current active tab index ---
    function getActiveTabIndex() {
        var tabLinks = document.querySelectorAll('.goal-tab-a');
        for (var i = 0; i < tabLinks.length; i++) {
            if (tabLinks[i].classList.contains('active-a')) return i;
        }
        return 0;
    }

    // --- Tab click handler ---
    var tabLinks = document.querySelectorAll('.goal-tab-a');
    tabLinks.forEach(function (tabLink, idx) {
        tabLink.addEventListener('click', function (e) {
            e.preventDefault();
            switchToTab(idx);
        });
    });

    // --- Set initial background gradient ---
    var sectionId = document.querySelector('.goal-selector-section')?.getAttribute('data-section-id');
    var section = sectionId ? document.querySelector('#shopify-section-' + sectionId) : null;
    if (section) {
        var activeTab = document.querySelector('#shopify-section-' + sectionId + ' .goal-tab-active');
        if (activeTab) {
            var gradient = activeTab.getAttribute('data-gradient');
            if (gradient) {
                section.style.background = gradient;
            }
        }
    }

    // --- Mobile: swipe on grid to change tabs ---
    initMobileSwipe();
    window.addEventListener('resize', initMobileSwipe);
});

function goalScroll(item) {
    var tabMenu = document.querySelector('.goal-selector-section .goal-tab-menu ul');
    if (tabMenu && item) {
        var itemRect = item.getBoundingClientRect();
        var containerRect = tabMenu.getBoundingClientRect();
        var scrollLeft = tabMenu.scrollLeft + (itemRect.left - containerRect.left);
        tabMenu.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
}

/* Mobile: detect horizontal swipe on the grid and switch tabs */
var _swipeBound = false;
function initMobileSwipe() {
    if (window.innerWidth >= 750) return;

    var grid = document.querySelector('.goal-selector-section__grid');
    if (!grid || _swipeBound) return;
    _swipeBound = true;

    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var isSwiping = false;
    var swipeThreshold = 50; // minimum px to count as a swipe

    grid.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isSwiping = true;
    }, { passive: true });

    grid.addEventListener('touchmove', function (e) {
        if (!isSwiping) return;
        var diffX = Math.abs(e.changedTouches[0].screenX - touchStartX);
        var diffY = Math.abs(e.changedTouches[0].screenY - touchStartY);

        // If horizontal movement is dominant, prevent vertical scroll
        if (diffX > diffY && diffX > 10) {
            e.preventDefault();
        }
    }, { passive: false });

    grid.addEventListener('touchend', function (e) {
        if (!isSwiping) return;
        isSwiping = false;

        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;

        var diffX = touchStartX - touchEndX;
        var diffY = Math.abs(touchStartY - touchEndY);

        // Only trigger if horizontal swipe is dominant
        if (Math.abs(diffX) < swipeThreshold || diffY > Math.abs(diffX)) return;

        var tabLinks = document.querySelectorAll('.goal-tab-a');
        var currentIndex = 0;
        tabLinks.forEach(function (link, i) {
            if (link.classList.contains('active-a')) currentIndex = i;
        });

        if (diffX > 0) {
            // Swiped left → next tab
            var nextIndex = currentIndex + 1;
            if (nextIndex < tabLinks.length) {
                switchToTabGlobal(nextIndex);
            }
        } else {
            // Swiped right → previous tab
            var prevIndex = currentIndex - 1;
            if (prevIndex >= 0) {
                switchToTabGlobal(prevIndex);
            }
        }
    }, { passive: true });
}

/* Global version of switchToTab (accessible outside DOMContentLoaded) */
function switchToTabGlobal(index) {
    var tabLinks = document.querySelectorAll('.goal-tab-a');
    if (index < 0 || index >= tabLinks.length) return;

    var targetLink = tabLinks[index];
    var tabId = targetLink.getAttribute('data-id');
    var tabNumber = targetLink.getAttribute('data-tab');

    // Update content tabs
    document.querySelectorAll('.goal-tab').forEach(function (tab) {
        tab.classList.remove('goal-tab-active');
    });
    var selectedTab = document.querySelector(".goal-tab[data-id='" + tabId + "']");
    if (selectedTab) {
        selectedTab.classList.add('goal-tab-active');
    }

    // Update tab pills
    tabLinks.forEach(function (link) {
        link.classList.remove('active-a');
    });
    targetLink.classList.add('active-a');

    // Update tab menu ul classes
    document.querySelectorAll('.goal-tab-menu ul').forEach(function (ul) {
        ul.className = '';
        ul.classList.add('goal-tab' + tabNumber);
    });

    // Switch images
    document.querySelectorAll('.goal-image-tabs').forEach(function (imgTab) {
        imgTab.classList.remove('goal-image-tabs-active');
    });
    var selectedImageTab = document.querySelector(".goal-image-tabs[data-id='goal-image-tab-" + tabId + "']");
    if (selectedImageTab) {
        selectedImageTab.classList.add('goal-image-tabs-active');
    }

    // Update section background gradient
    var sectionEl = document.querySelector('.goal-selector-section');
    if (sectionEl) {
        var sectionWrapper = document.querySelector('#shopify-section-' + sectionEl.getAttribute('data-section-id'));
        if (sectionWrapper && selectedTab) {
            var gradient = selectedTab.getAttribute('data-gradient');
            if (gradient) {
                sectionWrapper.style.background = gradient;
            }
        }
    }

    // Scroll tab pill into view
    goalScroll(targetLink);
}